// Public, non-secret site identity. Change the canonical origin here before deployment.
module.exports = {
  siteUrl: 'https://www.cctsvip.com',
  siteName: '五谷赛信',
  companyName: '广州赛信冷链冷藏科技有限公司',
  homeTitle: '五谷赛信 - 精准冷链温度控制与监控一站式解决方案',
  description: '广州赛信冷链冷藏科技有限公司专注精准冷链温度控制与监控，提供冷链保温箱、医药冷链包装、PCM相变材料、温湿度记录仪及冷链验证产品与服务。',
  logoPath: '/static/seo/ccts-brand-logo.png',
  // Fill only with verification codes issued for this site by each platform.
  verification: {
    'google-site-verification': '',
    'msvalidate.01': '',
    'baidu-site-verification': '',
    'sogou_site_verification': '',
    '360-site-verification': '',
  },
};



//////////////////
// WEBPACK FOOTER
// ./config/seo.js
// module id = yvkB
// module chunks = 49